import { FormField } from "@/ui-lib/components/Form";
import TextInput from "@/ui-lib/components/TextInput";
import { useTheme } from "@emotion/react";
import Flex from "@ternary/api-lib/ui-lib/components/Flex";
import React from "react";
import copyText from "../../copyText";
import { FullyQualifiedResourceString } from "../FullyQualifiedResourceString";
import {
  validateDatasetID,
  validateProjectID,
  validateTableID,
} from "./constants";
import { FormProps } from "./types";
const validators = {
  datasetID: ({ value }: { value: string }) => validateDatasetID(value),
  projectID: ({ value }: { value: string }) => validateProjectID(value),
  tableID: ({ value }: { value: string }) => validateTableID(value),
};

export function GcpIntegrationFormStandardBilling(props: FormProps) {
  const theme = useTheme();

  const { form } = props;

  const handleBQResourceChange = ([
    projectID,
    datasetID,
    tableID,
  ]: string[]) => {
    form.setFieldValue("projectIDStandard", projectID);
    form.setFieldValue("datasetIDStandard", datasetID);
    form.setFieldValue("tableIDStandard", tableID);

    // Trigger validation programmatically to update error state
    form.validateAllFields("change");
  };

  return (
    <Flex gap={theme.space_xxs} direction="column">
      <FullyQualifiedResourceString
        label={copyText.gcpFormBillingTableIDInputLabel}
        description={copyText.gcpFormStandardBillingTableIDInputCaption}
        onParse={handleBQResourceChange}
      />
      <Flex gap={theme.space_md} alignItems="center">
        <Flex flex="1 1 0">
          <form.Field
            name="projectIDStandard"
            validators={{
              onChange: validators.projectID,
              onMount: validators.projectID,
            }}
            children={(field) => {
              const shouldShowError =
                field.state.meta.isTouched &&
                field.state.meta.errors.length > 0;

              return (
                <FormField
                  input={TextInput}
                  caption={copyText.gcpFormBillingProjectIDInputCaption}
                  errorCaption={
                    shouldShowError
                      ? field.state.meta.errors.join(", ")
                      : undefined
                  }
                  label={copyText.gcpFormBillingProjectIDInputLabel}
                  value={field.state.value}
                  variant={shouldShowError ? "danger" : undefined}
                  onBlur={field.handleBlur}
                  onChange={(e) => field.handleChange(e.target.value)}
                />
              );
            }}
          />
        </Flex>
        <Flex flex="1 1 0">
          <form.Field
            name="datasetIDStandard"
            validators={{
              onChange: validators.datasetID,
              onMount: validators.datasetID,
            }}
            children={(field) => {
              const shouldShowError =
                field.state.meta.isTouched &&
                field.state.meta.errors.length > 0;

              return (
                <FormField
                  input={TextInput}
                  caption={copyText.gcpFormBillingDatasetIDInputCaption}
                  errorCaption={
                    shouldShowError
                      ? field.state.meta.errors.join(", ")
                      : undefined
                  }
                  label={copyText.gcpFormBillingDatasetIDInputLabel}
                  value={field.state.value}
                  variant={shouldShowError ? "danger" : undefined}
                  onBlur={field.handleBlur}
                  onChange={(e) => field.handleChange(e.target.value)}
                />
              );
            }}
          />
        </Flex>
      </Flex>
      <Flex gap={theme.space_md}>
        <Flex flex="1 1 0">
          <form.Field
            name="tableIDStandard"
            validators={{
              onChange: validators.tableID,
              onMount: validators.tableID,
            }}
            children={(field) => {
              const shouldShowError =
                field.state.meta.isTouched &&
                field.state.meta.errors.length > 0;

              return (
                <FormField
                  input={TextInput}
                  caption={copyText.gcpFormBillingTableNameInputCaption}
                  errorCaption={
                    shouldShowError
                      ? field.state.meta.errors.join(", ")
                      : undefined
                  }
                  label={copyText.gcpFormBillingTableNameLabel}
                  value={field.state.value}
                  variant={shouldShowError ? "danger" : undefined}
                  onBlur={field.handleBlur}
                  onChange={(e) => field.handleChange(e.target.value)}
                />
              );
            }}
          />
        </Flex>
      </Flex>
    </Flex>
  );
}
